export const CLOSED_ITEMS_HIDE_AFTER_DAYS = 30;

export type ClosedVisibility = 'default' | 'only_old' | 'all';

export const DEFAULT_CLOSED_VISIBILITY: ClosedVisibility = 'default';

export const CLOSED_VISIBILITY_OPTIONS: { value: ClosedVisibility; label: string }[] = [
  { value: 'default', label: `Padrão (ocultar após ${CLOSED_ITEMS_HIDE_AFTER_DAYS} dias)` },
  { value: 'only_old', label: `Somente concluídos há mais de ${CLOSED_ITEMS_HIDE_AFTER_DAYS} dias` },
  { value: 'all', label: 'Todo o histórico de concluídos' },
];

export function isClosedVisibility(value: unknown): value is ClosedVisibility {
  return value === 'default' || value === 'only_old' || value === 'all';
}

export function normalizeClosedVisibility(value: unknown): ClosedVisibility {
  return isClosedVisibility(value) ? value : DEFAULT_CLOSED_VISIBILITY;
}

/** Texto do chip de filtro ativo; null mantém o cabeçalho limpo na visão padrão. */
export function closedVisibilityChipLabel(visibility: ClosedVisibility): string | null {
  if (visibility === 'only_old') {
    return `Conclusão: somente há mais de ${CLOSED_ITEMS_HIDE_AFTER_DAYS} dias`;
  }
  if (visibility === 'all') {
    return 'Conclusão: histórico completo';
  }
  return null;
}

/**
 * Aviso sobre o recorte em vigor na listagem.
 *
 * As frases usam "com conclusão" em vez de concordar o adjetivo com o
 * substantivo para servir tanto a chamados quanto a requisições.
 */
export function closedVisibilityNotice(
  visibility: ClosedVisibility,
  hiddenTotal: number,
  nouns: { singular: string; plural: string }
): string | null {
  if (visibility === 'only_old') {
    return `Exibindo apenas ${nouns.plural} com conclusão há mais de ${CLOSED_ITEMS_HIDE_AFTER_DAYS} dias.`;
  }
  if (visibility === 'all') {
    return 'Exibindo todo o histórico, sem recorte por data de conclusão.';
  }
  if (hiddenTotal > 0) {
    const noun = hiddenTotal === 1 ? nouns.singular : nouns.plural;
    return `Ocultando ${hiddenTotal} ${noun} com conclusão há mais de ${CLOSED_ITEMS_HIDE_AFTER_DAYS} dias. Use o filtro "Conclusão" para consultá-los.`;
  }
  return null;
}
